<template>
  <div class="p-3">
    <v-data-table
      :headers="headers"
      :items="list"
      :loading="isLoading"
      loading-text="Chargement..."
      no-data-text="Aucune réponse"
    >
      <template v-slot:item.created_at="{ item }">
        {{ formatDate(item.created_at) }}
      </template>

      <template v-slot:item.name="{ item }">
        <router-link :to="'/summary/' + encodeUri(item.web_form.provider_id)">
          {{ item.provider_data_versions[0].name }}
        </router-link>
      </template>

      <template v-slot:item.actions="{ item }">
        <router-link :to="'answer/' + item.web_form.token">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="primary" v-bind="attrs" v-on="on">remove_red_eye
              </v-icon>
            </template>
            <span>Voir la réponse</span>
          </v-tooltip>
        </router-link>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: "MajList",
  props: ['list', 'isLoading'],
  data() {
    return {
      headers: [
        { text: "Nom", value: "name"},
        { text: "Reçue le", value: "created_at" },
        { text: "Actions", value: "actions", sortable: false },
      ],
    }
  },
  methods: {
    encodeUri(id) {
      return btoa(id)
    },
  }
}
</script>
